import { render, staticRenderFns } from "./ZahnwerkstattContactPage.vue?vue&type=template&id=ccf34f6a&scoped=true"
import script from "./ZahnwerkstattContactPage.vue?vue&type=script&lang=js"
export * from "./ZahnwerkstattContactPage.vue?vue&type=script&lang=js"
import style0 from "./ZahnwerkstattContactPage.vue?vue&type=style&index=0&id=ccf34f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf34f6a",
  null
  
)

export default component.exports